import React from 'react';

// Shows the whole photo inside a fixed-size box, whatever its shape: the image is contained (never
// cropped or stretched) over a blurred, darkened copy of itself that fills the leftover space.
// Partners upload portrait, square and landscape photos, and cards are all landscape.
// The parent must be position: relative (or absolute) with a set height.
const FitImage: React.FC<{ src: string; alt?: string }> = ({ src, alt = '' }) => (
  <span className="fit-img">
    <img className="fit-img-bg" src={src} alt="" aria-hidden="true" />
    <img className="fit-img-fg" src={src} alt={alt} loading="lazy" />
  </span>
);

export default FitImage;
